import styled from 'styled-components';

export const DashboardSummary = styled.div`
  display: flex;
  flex-flow: wrap;
  padding: 2rem;
  color: #BEBEBE;
`

export const Item = styled.div`
  width: 25%;
  margin-bottom: 2rem;
`

export const Label = styled.div`
  font-size: 90%;
  margin-bottom: 0.5rem;
`

export const Content = styled.div`
  font-weight: bold;
  font-size: 250%;

  .unit {
    font-size: 50%;
  }
`
